<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <ul class="nav nav-pills" role="tablist">
      @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
        <a (click)="activeTab = tab.id; currentTabName = tab.name" style="cursor: pointer;" class="btn-sm">{{ tab.name }}</a>
      </li>
}
    </ul>

    <div class="tab-content" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <!-- Form Entry tab -->
      @if (activeTab === 1) {
<div class="tab-pane active">
        <div class="form-horizontal tab-content-padding">
          <div class="row" style="margin: 20px 0 20px 0;">
            <div>
              <div class="row col-md-4 radio-inline">{{ assetsPlacedService[0]?.name }} &nbsp;&nbsp;&nbsp;&nbsp;</div>
              <div>
                <label class="radio-inline"><input type="radio" [disabled]="!AssetsCurrentYear" name="service" [value]="'Yes'"
                  [ngModel]="serDuringCurrYear" (ngModelChange)="serDuringCurrYear=$event; AssetChange()">Yes</label>
                <label class="radio-inline"><input type="radio" name="service" [disabled]="!AssetsCurrentYear" [value]="'No'"
                  [ngModel]="serDuringCurrYear" (ngModelChange)="serDuringCurrYear=$event; AssetChange()">No</label>
              </div>
            </div>
            @if (serDuringCurrYear==='Yes') {
<div class="row">
              <div class="row col-md-4 radio-inline">{{ bonusApplied[0]?.name }} &nbsp;&nbsp;&nbsp;&nbsp;</div>
              <div>
                <label class="radio-inline"><input type="radio" name="bonus" value="Bonus" [ngModel]="IsBonus" (ngModelChange)="IsBonus=$event; AssetChange()">Bonus</label>
                <label class="radio-inline"><input type="radio" name="bonus" value="Non_Bonus" [ngModel]="IsBonus" (ngModelChange)="IsBonus=$event; AssetChange()">Non Bonus</label>
              </div>
              <div class="row col-md-4 radio-inline">{{ methodAdopted[0]?.name }} &nbsp;&nbsp;&nbsp;&nbsp;</div>
              <div>
                <label class="radio-inline"><input type="radio" name="method" value="MACRS" [ngModel]="MethodAdopted" (ngModelChange)="MethodAdopted=$event; AssetChange()">MACRS</label>
                <label class="radio-inline"><input type="radio" name="method" value="SL" [ngModel]="MethodAdopted" (ngModelChange)="MethodAdopted=$event; AssetChange()">SL</label>
                <label class="radio-inline"><input type="radio" name="method" value="Book" [ngModel]="MethodAdopted" (ngModelChange)="MethodAdopted=$event; AssetChange()">Book</label>
                <label class="radio-inline"><input type="radio" name="method" value="Other" [ngModel]="MethodAdopted" (ngModelChange)="MethodAdopted=$event; AssetChange()">Other</label>
              </div>
            </div>
}
          </div>

          <div class="row">
            <table class="table table-bordered form-inline custom-table">
              <tbody class="text-right">
                <tr>
                  <td width="88%">{{ form4562DepExpPerTaxRet[0]?.name }}</td>
                  <td [ngClass]="{'color-red': form4562DepExpPerTaxRet[1]?.value < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ form4562DepExpPerTaxRet[1]?.value | numberWithCommas }}</strong></span></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row">
            <div class="col-md-12 font-weight-bold">
              <h4 style="font-weight: bold;">Part II: {{ data.partII.title }}</h4>
            </div>
            <table class="table table-bordered form-inline custom-table">
              <thead>
                <tr>
                  <th></th>
                  <th colspan="8" width="83.5%" class="text-center">{{ data.partII.tableTitle }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="80px">{{ form4562line14[0]?.name }}</td>
                  <td colspan="8">{{ form4562line14[1]?.name }}</td>
                  <td align="right">
                    <input class="form-control input-sm numText" style="text-align: right;" type="text"
                      [ngModel]="line14Amt" (ngModelChange)="line14Amt=$event; lineItemChange('14',0,0)"
                      onlyDigitsDecimal (blur)="setDepDeduct('14',false,0)">
                  </td>
                </tr>
                <tr>
                  <td>{{ form4562line16[0]?.name }}</td>
                  <td colspan="8">{{ form4562line16[1]?.name }}</td>
                  <td align="right">
                    <input class="form-control input-sm numText" style="text-align: right;" type="text"
                      [ngModel]="line16Amt" (ngModelChange)="line16Amt=$event; lineItemChange('16',0,0)"
                      onlyDigitsDecimal (blur)="setDepDeduct('16',false,0)">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part III: {{ data.partIII.title }}</h4>
            </div>
            <table class="table table-bordered form-inline custom-table">
              <tr>
                <td width="80px">{{ form4562line17[0]?.name }}</td>
                <td colspan="8" width="83.5%">{{ form4562line17[1]?.name }}</td>
                <td align="right">
                  <input class="form-control input-sm numText" style="text-align: right;" type="text"
                    [ngModel]="line17Amt" (ngModelChange)="line17Amt=$event; lineItemChange('17',0,0)"
                    onlyDigitsDecimal (blur)="setDepDeduct('17',false,0)">
                </td>
              </tr>
            </table>
            <table class="table table-bordered form-inline custom-table">
              <thead>
                <tr>
                  @for (header of line19Headers; track $index) {
<th [id]="'19_'+header?.key">{{ header?.name }}</th>
}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ line19DetHeader[0]?.name }}</td>
                  <td colspan="8"><h5>{{ line19DetHeader[1]?.name }}</h5></td>
                </tr>
                @for (row of line19AllDetails; track $index; let ri = $index) {
<tr>
                  <td>{{ row[1]?.name }}</td>
                  <td>{{ row[2]?.name }}</td>
                  <td><input class="form-control" [ngModel]="row[3]?.value" (ngModelChange)="row[3].value=$event; lineItemChange('19'+row[1]?.name,0,3)" [disabled]="row[3]?.property?.is_editable_cell !== 'Y'"></td>
                  <td><input class="form-control input-sm numText" [ngModel]="row[4]?.value" (ngModelChange)="row[4].value=$event; lineItemChange('19'+row[1]?.name,0,4)" style="text-align: right;" type="text" onlyDigitsDecimal></td>
                  <td><input class="form-control" [ngModel]="row[5]?.value" (ngModelChange)="row[5].value=$event; lineItemChange('19'+row[1]?.name,0,5)" type="number" style="text-align: right;" step="0.01" [disabled]="row[5]?.property?.is_editable_cell !== 'Y'"> Yrs</td>
                  <td>
                    <select class="form-control" [ngModel]="row[6]?.value" (ngModelChange)="row[6].value=$event; lineItemChange('19'+row[1]?.name,0,6)" [disabled]="row[6]?.property?.is_editable_cell !== 'Y'">
                      @for (conv of data.partIII.convensions; track $index) {
<option [value]="conv">{{ conv }}</option>
}
                    </select>
                  </td>
                  <td width="340px">
                    <select class="form-control" [ngModel]="row[7]?.value" (ngModelChange)="row[7].value=$event; lineItemChange('19'+row[1]?.name,0,7)" [disabled]="row[7]?.property?.is_editable_cell !== 'Y'">
                      @for (method of data.partIII.methods; track $index) {
<option [value]="method">{{ method }}</option>
}
                    </select>
                  </td>
                  <td align="right"><input class="form-control input-sm numText" [ngModel]="row[8]?.value" (ngModelChange)="row[8].value=$event; lineItemChange('19'+row[1]?.name,0,8)" style="text-align: right;" type="text" onlyDigitsDecimal (blur)="setDepDeduct('19'+row[1]?.name,false,0)"></td>
                </tr>
}
                <tr>
                  <td>{{ line20DetHeader[0]?.name }}</td>
                  <td colspan="8"><h5>{{ line20DetHeader[1]?.name }}</h5></td>
                </tr>
                @for (row of line20AllDetails; track $index; let ri = $index) {
<tr>
                  <td>{{ row[1]?.name }}</td>
                  <td>{{ row[2]?.name }}</td>
                  <td><input class="form-control" [ngModel]="row[3]?.value" (ngModelChange)="row[3].value=$event; lineItemChange('20'+row[1]?.name,0,3)" [disabled]="row[3]?.property?.is_editable_cell !== 'Y'"></td>
                  <td><input class="form-control input-sm numText" [ngModel]="row[4]?.value" (ngModelChange)="row[4].value=$event; lineItemChange('20'+row[1]?.name,0,4)" style="text-align: right;" type="text" onlyDigitsDecimal></td>
                  <td><input class="form-control" [ngModel]="row[5]?.value" (ngModelChange)="row[5].value=$event; lineItemChange('20'+row[1]?.name,0,5)" type="number" style="text-align: right;" step="0.01" [disabled]="row[5]?.property?.is_editable_cell !== 'Y'"> Yrs</td>
                  <td>
                    <select class="form-control" [ngModel]="row[6]?.value" (ngModelChange)="row[6].value=$event; lineItemChange('20'+row[1]?.name,0,6)" [disabled]="row[6]?.property?.is_editable_cell !== 'Y'">
                      <option value="">Select</option>
                      @for (conv of data.partIII.convensions; track $index) {
<option [value]="conv">{{ conv }}</option>
}
                    </select>
                  </td>
                  <td>
                    <select class="form-control" [ngModel]="row[7]?.value" (ngModelChange)="row[7].value=$event; lineItemChange('20'+row[1]?.name,0,7)" [disabled]="row[7]?.property?.is_editable_cell !== 'Y'">
                      <option value="">Select</option>
                      @for (method of data.partIII.methods; track $index) {
<option [value]="method">{{ method }}</option>
}
                    </select>
                  </td>
                  <td align="right"><input class="form-control input-sm numText" [ngModel]="row[8]?.value" (ngModelChange)="row[8].value=$event; lineItemChange('20'+row[1]?.name,0,8)" style="text-align: right;" type="text" onlyDigitsDecimal (blur)="setDepDeduct('20'+row[1]?.name,false,0)"></td>
                </tr>
}
              </tbody>
            </table>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part V: {{ data.partV.title }}</h4>
            </div>
            <table class="table table-bordered form-inline custom-table">
              <tr>
                <td width="80px">{{ form4562line25[0]?.name }}</td>
                <td colspan="8" width="83.5%">{{ form4562line25[1]?.name }}</td>
                <td align="right">
                  <input class="form-control input-sm numText" style="text-align: right;" type="text"
                    [ngModel]="line25Amt" (ngModelChange)="line25Amt=$event; lineItemChange('25',0,0)"
                    onlyDigitsDecimal (blur)="setDepDeduct('25',false,0)">
                </td>
              </tr>
            </table>
            <table class="table table-bordered form-inline custom-table">
              <thead>
                <tr>
                  @for (header of line26Headers; track $index) {
<th [id]="'26_'+header?.key">{{ header?.name }}</th>
}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="82px">26 <i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Add Details" (click)="addSection(26)"></i></td>
                  <td colspan="9">Add Details</td>
                </tr>
                @for (row of data.partV.rows; track $index; let i = $index) {
<tr>
                  <td><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Remove Details" (click)="sectionRemove(26,i)"></i></td>
                  <td><input class="form-control input-sm" type="text" [ngModel]="formData_26.addrows[i]?.[0]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][0].Attribute_Value=$event"></td>
                  <td><input class="form-control input-sm" type="date" [ngModel]="formData_26.addrows[i]?.[1]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][1].Attribute_Value=$event"></td>
                  <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_26.addrows[i]?.[2]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][2].Attribute_Value=$event"></td>
                  <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_26.addrows[i]?.[3]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][3].Attribute_Value=$event"></td>
                  <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_26.addrows[i]?.[4]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][4].Attribute_Value=$event"></td>
                  <td>
                    <select class="form-control input-sm" [ngModel]="formData_26.addrows[i]?.[5]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][5].Attribute_Value=$event; errorChange(26,i,5)">
                      @for (period of data.selectPeriod; track $index) {
<option [value]="period">{{ period }}</option>
}
                    </select> Yrs
                  </td>
                  <td>
                    <select class="form-control input-sm" [ngModel]="formData_26.addrows[i]?.[6]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][6].Attribute_Value=$event; errorChange(26,i,6)">
                      @for (method of data.selectMethod; track $index) {
<option [value]="method">{{ method }}</option>
}
                    </select>
                    <select class="form-control input-sm" [ngModel]="formData_26.addrows[i]?.[7]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][7].Attribute_Value=$event; errorChange(26,i,7)">
                      @for (convention of data.selectConvention; track $index) {
<option [value]="convention">{{ convention }}</option>
}
                    </select>
                  </td>
                  <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_26.addrows[i]?.[8]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][8].Attribute_Value=$event"></td>
                  <td align="right"><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_26.addrows[i]?.[9]?.Attribute_Value" (ngModelChange)="formData_26.addrows[i][9].Attribute_Value=$event" (blur)="setDepDeduct('26',false,i)"></td>
                </tr>
}
                @for (t of form4562Line26Records; track $index; let i = $index) {
<tr [id]="t.rowDimensions?.object_id">
                  <td>
                    <i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer; margin-top: 4px;" title="Edit Details" (click)="pencilButtonClicked(26,i,t.rowDimensions?.object_id)"></i>
                    @if (displayDeleteIcon_26[i]) {
<span><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Remove Details" (click)="removeExistingRecord(26,i,t.rowDimensions?.object_id)"></i></span>
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span>{{ t.dataCellList[1]?.value }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm" type="text" [ngModel]="t.dataCellList[1]?.value" (ngModelChange)="t.dataCellList[1].value=$event; lineItemChange('26',i,0)">
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span>{{ t.dataCellList[2]?.value | date:'MM/dd/yyyy' }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm" type="date" [ngModel]="t.dataCellList[2]?.value" (ngModelChange)="t.dataCellList[2].value=$event; lineItemChange('26',i,1)">
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span [ngClass]="{'color-red': t.dataCellList[3]?.value < 0 }">{{ t.dataCellList[3]?.value | numberWithCommas }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[3]?.value" (ngModelChange)="t.dataCellList[3].value=$event; lineItemChange('26',i,2)">
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span [ngClass]="{'color-red': t.dataCellList[4]?.value < 0 }">{{ t.dataCellList[4]?.value | numberWithCommas }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[4]?.value" (ngModelChange)="t.dataCellList[4].value=$event; lineItemChange('26',i,3)">
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span [ngClass]="{'color-red': t.dataCellList[5]?.value < 0 }">{{ t.dataCellList[5]?.value | numberWithCommas }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[5]?.value" (ngModelChange)="t.dataCellList[5].value=$event; lineItemChange('26',i,4)">
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span>{{ t.dataCellList[6]?.value }} Yrs</span>
}
                    @if (displayEditValue_26[i]) {
<span>
                      <select class="form-control input-sm" [ngModel]="t.dataCellList[6]?.value" (ngModelChange)="t.dataCellList[6].value=$event; lineItemChange('26',i,5)">
                        @for (period of data.selectPeriod; track $index) {
<option [value]="period">{{ period }}</option>
}
                      </select> Yrs
                    </span>
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span>{{ t.dataCellList[7]?.value }} / {{ t.dataCellList[8]?.value }}</span>
}
                    @if (displayEditValue_26[i]) {
<span>
                      <select class="form-control input-sm" [ngModel]="t.dataCellList[7]?.value" (ngModelChange)="t.dataCellList[7].value=$event; lineItemChange('26',i,6)">
                        @for (method of data.selectMethod; track $index) {
<option [value]="method">{{ method }}</option>
}
                      </select>
                      <select class="form-control input-sm" [ngModel]="t.dataCellList[8]?.value" (ngModelChange)="t.dataCellList[8].value=$event; lineItemChange('26',i,7)">
                        @for (convention of data.selectConvention; track $index) {
<option [value]="convention">{{ convention }}</option>
}
                      </select>
                    </span>
}
                  </td>
                  <td>
                    @if (displayViewValue_26[i]) {
<span [ngClass]="{'color-red': t.dataCellList[9]?.value < 0 }">{{ t.dataCellList[9]?.value | numberWithCommas }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[9]?.value" (ngModelChange)="t.dataCellList[9].value=$event; lineItemChange('26',i,8)">
}
                  </td>
                  <td align="right">
                    @if (displayViewValue_26[i]) {
<span [ngClass]="{'color-red': t.dataCellList[10]?.value < 0 }">{{ t.dataCellList[10]?.value | numberWithCommas }}</span>
}
                    @if (displayEditValue_26[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[10]?.value" (ngModelChange)="t.dataCellList[10].value=$event; lineItemChange('26',i,9)" (blur)="setDepDeduct('26',true,i)">
}
                  </td>
                </tr>
}
              </tbody>
              <tfoot>
                <tr>
                  <td class="text-right" colspan="9">{{ totalDepExpPer4562[0]?.name }}</td>
                  <td colspan="2" align="right" [ngClass]="{'color-red': totalDepExpPer4562[1]?.value < 0 }">{{ totalDepExpPer4562[1]?.value | numberWithCommas }}</td>
                </tr>
                <tr>
                  <td class="text-right" colspan="9">{{ unallocatedAmt[0]?.name }}</td>
                  <td colspan="2" align="right" [ngClass]="{'color-red': unallocatedAmt[1]?.value < 0 }">{{ unallocatedAmt[1]?.value | numberWithCommas }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part VI: {{ data.partVI.title }}</h4>
            </div>
            <div class="form-inline">
              <table class="table table-bordered form-inline custom-table">
                <thead>
                  <tr>
                    @for (header of line42Headers; track $index) {
<th [id]="'42_'+header?.key">{{ header?.name }}</th>
}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-right" colspan="6">{{ totAmortAmtPerTaxRet[0]?.name }}</td>
                    <td colspan="3" align="right" [ngClass]="{'color-red': totAmortAmtPerTaxRet[1]?.value < 0 }">{{ totAmortAmtPerTaxRet[1]?.value | numberWithCommas }}</td>
                  </tr>
                  <tr>
                    <td width="82px">42 <i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Add Details" (click)="addSection(42)"></i></td>
                    <td colspan="6">Amortization of costs that begins during current tax year (Add Details)</td>
                  </tr>
                  @for (row of data.partVI.rows; track $index; let i = $index) {
<tr>
                    <td><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Remove Details" (click)="sectionRemove(42,i)"></i></td>
                    <td><input class="form-control input-sm" type="text" [ngModel]="formData_42.addrows[i]?.[0]?.Attribute_Value" (ngModelChange)="formData_42.addrows[i][0].Attribute_Value=$event; errorChange(42,i,0)"></td>
                    <td><input class="form-control input-sm" type="date" [ngModel]="formData_42.addrows[i]?.[1]?.Attribute_Value" (ngModelChange)="formData_42.addrows[i][1].Attribute_Value=$event; errorChange(42,i,1)"></td>
                    <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_42.addrows[i]?.[2]?.Attribute_Value" (ngModelChange)="formData_42.addrows[i][2].Attribute_Value=$event; errorChange(42,i,2)"></td>
                    <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_42.addrows[i]?.[3]?.Attribute_Value" (ngModelChange)="formData_42.addrows[i][3].Attribute_Value=$event; errorChange(42,i,3)"></td>
                    <td><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_42.addrows[i]?.[4]?.Attribute_Value" (ngModelChange)="formData_42.addrows[i][4].Attribute_Value=$event; errorChange(42,i,4)"></td>
                    <td align="right"><input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="formData_42.addrows[i]?.[5]?.Attribute_Value" (ngModelChange)="formData_42.addrows[i][5].Attribute_Value=$event; errorChange(42,i,5)" (blur)="setDepDeduct('42',false,i)"></td>
                  </tr>
}
                  @for (t of form4562Line42Records; track $index; let i = $index) {
<tr [id]="t.rowDimensions?.object_id">
                    <td>
                      <i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer; margin-top: 4px;" title="Edit Details" (click)="pencilButtonClicked(42,i,t.rowDimensions?.object_id)"></i>
                      @if (displayDeleteIcon_42[i]) {
<span><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Remove Details" (click)="removeExistingRecord(42,i,t.rowDimensions?.object_id)"></i></span>
}
                    </td>
                    <td>
                      @if (displayViewValue_42[i]) {
<span>{{ t.dataCellList[1]?.value }}</span>
}
                      @if (displayEditValue_42[i]) {
<input class="form-control input-sm" type="text" [ngModel]="t.dataCellList[1]?.value" (ngModelChange)="t.dataCellList[1].value=$event; lineItemChange('42',i,0)">
}
                    </td>
                    <td>
                      @if (displayViewValue_42[i]) {
<span>{{ t.dataCellList[2]?.value | date:'MM/dd/yyyy' }}</span>
}
                      @if (displayEditValue_42[i]) {
<input class="form-control input-sm" type="date" [ngModel]="t.dataCellList[2]?.value" (ngModelChange)="t.dataCellList[2].value=$event; lineItemChange('42',i,1)">
}
                    </td>
                    <td>
                      @if (displayViewValue_42[i]) {
<span [ngClass]="{'color-red': t.dataCellList[3]?.value < 0 }">{{ t.dataCellList[3]?.value | numberWithCommas }}</span>
}
                      @if (displayEditValue_42[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[3]?.value" (ngModelChange)="t.dataCellList[3].value=$event; lineItemChange('42',i,2)">
}
                    </td>
                    <td>
                      @if (displayViewValue_42[i]) {
<span [ngClass]="{'color-red': t.dataCellList[4]?.value < 0 }">{{ t.dataCellList[4]?.value | numberWithCommas }}</span>
}
                      @if (displayEditValue_42[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[4]?.value" (ngModelChange)="t.dataCellList[4].value=$event; lineItemChange('42',i,3)">
}
                    </td>
                    <td>
                      @if (displayViewValue_42[i]) {
<span>{{ t.dataCellList[5]?.value }}</span>
}
                      @if (displayEditValue_42[i]) {
<span>
                        <select class="form-control input-sm" [ngModel]="t.dataCellList[5]?.value" (ngModelChange)="t.dataCellList[5].value=$event; lineItemChange('42',i,4)">
                          <option value="">Select</option>
                          @for (period of data.selectPeriodStr; track $index) {
<option [value]="period">{{ period }}</option>
}
                        </select>
                      </span>
}
                    </td>
                    <td align="right">
                      @if (displayViewValue_42[i]) {
<span [ngClass]="{'color-red': t.dataCellList[6]?.value < 0 }">{{ t.dataCellList[6]?.value | numberWithCommas }}</span>
}
                      @if (displayEditValue_42[i]) {
<input class="form-control input-sm numText" style="text-align: right;" type="text" onlyDigitsDecimal [ngModel]="t.dataCellList[6]?.value" (ngModelChange)="t.dataCellList[6].value=$event; lineItemChange('42',i,5)" (blur)="setDepDeduct('42',true,i)">
}
                    </td>
                  </tr>
}
                </tbody>
              </table>
              <table class="table table-bordered form-inline custom-table">
                <tr>
                  <td width="80px">{{ form4562line43[0]?.name }}</td>
                  <td colspan="8" width="83.5%">{{ form4562line43[1]?.name }}</td>
                  <td align="right">
                    <input class="form-control input-sm numText" style="text-align: right;" type="text"
                      [ngModel]="line43Amt" (ngModelChange)="line43Amt=$event; lineItemChange('43',0,0)"
                      onlyDigitsDecimal (blur)="setDepDeduct('43',false,0)">
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
}

      <!-- Form View tab -->
      @if (activeTab === 2) {
<div class="tab-pane active">
        <div class="form-horizontal tab-content-padding">
          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold; padding-top: 15px;">Part I: {{ FormViewData.partI?.title }}</h4>
            </div>
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  @for (column of FormViewData.partI?.columns; track $index; let i = $index) {
<th>{{ column }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of FormViewData.partI?.rows; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.descriptionOfProperty }}</td>
                  <td></td>
                </tr>
}
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part II: {{ FormViewData.partII?.title }}</h4>
            </div>
            <table class="table table-bordered custom-table">
              @for (row of FormViewData.partII?.rows; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.value }}</td>
              </tr>
}
            </table>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part III: {{ FormViewData.partIII?.title }}</h4>
            </div>
            <table class="table table-bordered custom-table">
              @for (row of FormViewData.partIII?.table; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.value }}</td>
                <td></td>
              </tr>
}
            </table>
            @for (section of FormViewData.partIII?.sections; track $index) {

              <div class="text-center"><h4>{{ section.title }}</h4></div>
              <table class="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th></th>
                    @for (header of section.columns; track $index) {
<th>{{ header }}</th>
}
                  </tr>
                </thead>
                <tbody>
                  @for (row of section.rows; track $index) {
<tr>
                    <td>{{ row.num }}</td>
                    <td>{{ row.classification }}</td>
                    <td></td>
                    <td>{{ row.basisForDeprication }}</td>
                    <td>{{ row.recoveryPeriod }}</td>
                    <td>{{ row.convension }}</td>
                    <td>{{ row.method }}</td>
                    <td>{{ row.depricationDeduction }}</td>
                  </tr>
}
                </tbody>
              </table>
            
}
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part IV: {{ FormViewData.partIV?.title }}</h4>
            </div>
            <table class="table table-bordered custom-table">
              @for (row of FormViewData.partIV?.rows; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.value }}</td>
              </tr>
}
            </table>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part V: {{ FormViewData.partV?.title }}</h4>
            </div>
            @for (section of FormViewData.partV?.sections; track $index) {

              <div class="text-center"><h4>{{ section.title }}</h4></div>
              <table class="table table-bordered custom-table">
                <tbody>
                  @for (row of FormViewData.partV?.rows; track $index) {
<tr>
                    <td>{{ row.num }}</td>
                    <td>{{ row.value }}</td>
                    <td><label class="radio-inline"><input type="radio" name="yes">{{ row.yes }}</label></td>
                    <td><label class="radio-inline"><input type="radio" name="yes">{{ row.no }}</label></td>
                  </tr>
}
                </tbody>
              </table>
            
}
            @if (FormViewData.partV?.section1; as section1) {
<table class="table table-bordered custom-table">
              <thead>
                <tr>
                  <th></th>
                  @for (column of section1.columns; track $index) {
<th>{{ column }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of section1.rows; track $index) {
<tr>
                  @for (rowVal of row; track $index) {
<td [attr.colspan]="rowVal.size">{{ rowVal.text }}@if (rowVal.units) {
<span class="pull-right">{{ rowVal.units }}</span>
}</td>
}
                </tr>
}
              </tbody>
            </table>
}
            @for (section of FormViewData.partV?.sections; track $index) {

              <table class="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    @for (header of section.columns; track $index) {
<th colspan="2">{{ header }}</th>
}
                  </tr>
                </thead>
                <tbody>
                  @for (row of section.rows; track $index) {
<tr>
                    <td>{{ row.num }}</td>
                    <td>{{ row.value }}</td>
                    @for (yesOrNo of (row.vehicle1 || ['']); track $index) {
<td [attr.colspan]="row.vehicle1?.length ? 1 : 2">{{ yesOrNo }}</td>
}
                    @for (yesOrNo of (row.vehicle2 || ['']); track $index) {
<td [attr.colspan]="row.vehicle2 ? 1 : 2">{{ yesOrNo }}</td>
}
                    @for (yesOrNo of (row.vehicle3 || ['']); track $index) {
<td [attr.colspan]="row.vehicle3 ? 1 : 2">{{ yesOrNo }}</td>
}
                    @for (yesOrNo of (row.vehicle4 || ['']); track $index) {
<td [attr.colspan]="row.vehicle4 ? 1 : 2">{{ yesOrNo }}</td>
}
                    @for (yesOrNo of (row.vehicle5 || ['']); track $index) {
<td [attr.colspan]="row.vehicle5 ? 1 : 2">{{ yesOrNo }}</td>
}
                    @for (yesOrNo of (row.vehicle6 || ['']); track $index) {
<td [attr.colspan]="row.vehicle6 ? 1 : 2">{{ yesOrNo }}</td>
}
                  </tr>
}
                </tbody>
              </table>
            
}
            @if (FormViewData.partV?.sectionB2; as sectionB2) {
<div class="col-md-12 text-center">
              <h4 style="font-weight: bold">{{ sectionB2.title }}</h4>
            </div>
}
            @if (FormViewData.partV?.sectionB2; as sectionB2) {
<table class="table table-bordered custom-table">
              <thead>
                <tr>
                  @for (col of sectionB2.columns; track $index; let i = $index) {
<td>{{ col }}</td>
}
                </tr>
              </thead>
              <tbody>
                @for (row of sectionB2.rows; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.text }}</td>
                  <td>{{ row.yes }}</td>
                  <td>{{ row.no }}</td>
                </tr>
}
              </tbody>
            </table>
}
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 style="font-weight: bold;">Part VI: {{ FormViewData.partVI?.title }}</h4>
            </div>
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  <th></th>
                  @for (column of FormViewData.partVI?.columns; track $index; let i = $index) {
<th>{{ column }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of FormViewData.partVI?.rows; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.value }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked || crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
